import styled from 'styled-components'


export const Sessions = styled.div`
  text-align: center;
  margin: 32px;

  button {
    border: none;
    background: none;
    font-size: 18px;
    margin: 12px;
  }

  .session-selected {
    font-size: 19px;
    font-weight: 600;
    border-bottom: solid 2px ${props => props.brandcolor};
  }

  @media only screen and (aspect-ratio: 9/16) {
    margin: 48px 16px 24px 16px;

    button {
      font-size: 16px;
      margin: 8px;
      padding: 8px 16px;
    }

    .session-selected {
      font-size: 17px;
    }
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 88%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  margin-top: 40px;

  @media only screen and (aspect-ratio: 9/16) {
    height: calc(100vh - 96px);
    margin-top: 48px;
    overflow-y: auto;
  }

`